export const ceremonyMap: Map<string, Map<string, string>> = new Map([
  [
    '2025-05-28 10:00',
    new Map([
      ['School of Engineering and Schwarzman College of Computing Advanced Degree Ceremony', '87'],
      ['School of Science Advanced Degree Ceremony', '90']
    ])
  ],
  [
    '2025-05-29 10:00',
    new Map([
      ['OneMIT Commencement Ceremony', '85'],
      ['School of Architecture and Planning Advanced Degree Ceremony', '88'],
      ['School of Humanities, Arts, and Social Sciences Advanced Degree Ceremony', '89'],
      ['Sloan School of Management Doctoral Hooding Ceremony', '94'],
      ['Sloan School of Management Executive MBA Ceremony', '95'],
      ['Sloan School of Management Master of Finance Ceremony', '93'],
      ['Sloan School of Management Master of Science Management Studies Ceremony', '92']
    ])
  ],
  [
    '2025-05-30 10:00',
    new Map([
      ['Sloan School of Management MBA Ceremony', '96'],
      ['Sloan School of Management MIT Sloan Fellows MBA Ceremony', '91'],
      ['Undergraduate Degree Ceremony', '86']
    ])
  ]
])

export const flatMap: Map<string, string> = new Map(
  Array.from(ceremonyMap.values()).flatMap((innerMap) =>
    Array.from(innerMap.entries())
  )
);
